export const CUSTOM_COLORS = {
    colors: [
        {
            color: 'rgb(0, 0, 0)',
            label: 'Black',
            class: 'ck-color-black',
        },
        {
            color: 'rgb(77, 77, 77)',
            label: 'Dim grey',
            class: 'ck-color-dim-grey',
        },
        {
            color: 'rgb(153, 153, 153)',
            label: 'Grey',
            class: 'ck-color-grey',
        },
        {
            color: 'rgb(230, 230, 230)',
            label: 'Light grey',
            class: 'ck-color-light-grey',
        },
        {
            color: 'rgb(255, 255, 255)',
            label: 'White',
            class: 'ck-color-white',
        },
        {
            color: 'rgb(230, 77, 77)',
            label: 'Red',
            class: 'ck-color-red',
        },
        {
            color: 'rgb(230, 153, 77)',
            label: 'Orange',
            class: 'ck-color-orange',
        },
        {
            color: 'rgb(230, 230, 77)',
            label: 'Yellow',
            class: 'ck-color-yellow',
        },
        {
            color: 'rgb(153, 230, 77)',
            label: 'Light green',
            class: 'ck-color-light-green',
        },
        {
            color: 'rgb(77, 230, 77)',
            label: 'Green',
            class: 'ck-color-green',
        },
        {
            color: 'rgb(77, 230, 153)',
            label: 'Aquamarine',
            class: 'ck-color-aquamarine',
        },
        {
            color: 'rgb(77, 230, 230)',
            label: 'Turquoise',
            class: 'ck-color-turquoise',
        },
        {
            color: 'rgb(77, 153, 230)',
            label: 'Light blue',
            class: 'ck-color-light-blue',
        },
        {
            color: 'rgb(77, 77, 230)',
            label: 'Blue',
            class: 'ck-color-blue',
        },
        {
            color: 'rgb(153, 77, 230)',
            label: 'Purple',
            class: 'ck-color-purple',
        },
    ],
};
